import { InputItem, List, WhiteSpace, Button, Toast } from "antd-mobile-v2";
import React, { Component } from "react";
import { createForm } from "rc-form";
import "./index.less";
import { get, postRaw } from "../../../api/service/services";
import sectioValue from "../../../api/service/secsstion";
import allUrl from "../../../api/allUrl";
const tabs = [{ title: "账号登录" }, { title: "短信登录" }];
const Item = List.Item;
class MessLogin extends React.Component {
  constructor() {
    super();
    this.state = {
      count: 60,
      flagCode: true,
    };
  }
  // 获取验证码
  isPhone = () => {
    const { flagCode } = this.state;
    let phoneS = this.props.form.getFieldValue("phoneNumber");
    if (!phoneS) {
      Toast.fail("请输入手机号", 1);
      return;
    }
    if (!flagCode) {
      return;
    }
    get(allUrl.register.getIsPhoneCode, { phone: phoneS })
      .then((res) => {
        if (res.success === true && res.code == 200) {
          this.countDown();
        } else {
          Toast.info(res.msg, 1);
        }
      })
      .catch((error) => {
        Toast.info("验证码获取失败", 1);
      });
  };

  // 倒计时
  countDown = () => {
    const { count, flagCode } = this.state;
    let timer = null;
    let num = count;
    this.setState({
      flagCode: false,
    });
    timer = setInterval(() => {
      if (num <= 1) {
        clearInterval(timer);
        num = 60;
        this.setState({
          flagCode: true,
        });
      }
      num--;
      this.setState({
        count: num,
      });
    }, 1000);
  };
  validateAccount = (rule, value, callback) => {
    if (value && value.length > 4) {
      callback();
    } else {
      callback(new Error("At least four characters for account"));
    }
  };
  // 数据提交
  onSubmit = () => {
    this.props.form.validateFields((error, values) => {
      if (error) {
        let errorData = Object.keys(error)[0];
        Toast.info(error[errorData].errors[0].message, 1);
        return;
      }
      values["grant_type"] = "captcha";
      values["scope"] = "all";
      this.submitData(values);
    });
  };
  //数据提交
  submitData = (data) => {
    postRaw(allUrl.register.userLogin, data, {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: "Basic c3dvcmQ6c3dvcmRfc2VjcmV0",
    })
      .then((res) => {
        if (res && res.access_token && res.token_type && res.account) {
          let num = new Date().getTime() + (1000 * 60 * 15 - 4000);
          sectioValue.set("tokenTime", num);
          sectioValue.set("refstoken", `${res.refresh_token}`);
          sectioValue.set("token", `${res.token_type}   ${res.access_token}`);
          sectioValue.set("acount", res.account);
          sectioValue.set("user_id", res.user_id);
          sectioValue.set("nick_name", res.nick_name);
          this.props.props.history.push("/home");
        } else {
          Toast.info("登录失败", 1);
        }
      })
      .catch((error) => {
        if (error.data && error.data.msg) {
          Toast.info(error.data.msg, 1);
        } else {
          Toast.info("登录失败", 1);
        }
      });
  };

  render() {
    const { getFieldProps, getFieldError } = this.props.form;
    const { flagCode, count } = this.state;
    return (
      <div className="message-login-wrap">
        <form>
          <InputItem
            {...getFieldProps("phoneNumber", {
              rules: [
                { required: true, message: "请输入手机号" },
                {
                  required: false,
                  pattern: new RegExp(/^1(3|4|5|6|7|8|9)\d{9}$/, "g"),
                  message: "请输入正确的手机号",
                },
              ],
            })}
            placeholder="请输入手机号"
            type=""
            labelNumber={3}
            maxLength={50}
          >
            <div>+86</div>
          </InputItem>
          <WhiteSpace />
          <div style={{ position: "relative" }}>
            <InputItem
              {...getFieldProps("smsCaptcha")}
              placeholder="请输入验证码"
              type=""
              labelNumber={3}
              maxLength={6}
            >
              <div>验证码</div>
            </InputItem>
            <div
              className="code-image"
              onClick={() => {
                this.isPhone();
              }}
              style={{
                color: flagCode ? "#337fd3" : "#ccc",
                borderColor:flagCode ? "#337fd3" : "#ccc",
              }}
            >
              {flagCode ? "获取验证码" : `${count}S重新获取`}
            </div>
          </div>
          <WhiteSpace />
          <WhiteSpace />
          <WhiteSpace />
          <div
            style={{
              position: "absolute",
              left: "0rem",
              bottom: "0rem",
              width: "100%",
              padding: "0 0.1rem",
            }}
          >
            <Button
              type="primary"
              onClick={this.onSubmit}
              style={{ width: "100%" }}
            >
              登录
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

export default createForm()(MessLogin);
